import React from "react";
export function AgaveMark({
  className = ""
}: {
  className?: string;
}) {
  return <svg viewBox="0 0 120 80" aria-hidden="true" className={className} data-id="element-55" data-mp="owvatsjtai7u">
      <path d="M60 76C50 60 30 46 6 40C20 56 38 70 60 76Z" fill="#0F6B4A" data-id="element-56" data-mp="ouilgubq55kr" />
      <path d="M60 76C70 60 90 46 114 40C100 56 82 70 60 76Z" fill="#0F6B4A" data-id="element-57" data-mp="12pkvntnlth3d" />
      <path d="M60 76C58 54 46 30 28 12C34 36 44 58 60 76Z" fill="#1F4E9C" data-id="element-58" data-mp="xw8iqgsaeyqg" />
      <path d="M60 76C62 54 74 30 92 12C86 36 76 58 60 76Z" fill="#1F4E9C" data-id="element-59" data-mp="1clo7xsc66w41" />
      <path d="M60 2C67 26 67 52 60 76C53 52 53 26 60 2Z" fill="#1CA7A8" data-id="element-60" data-mp="17n38vw8nmih6" />
    </svg>;
}